import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { OperacionesCacheProvider } from './contexts/OperacionesCacheContext';
import { useAuth } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import NotificacionesModal from './components/NotificacionesModal';
import Home from './pages/Home';
import ProjectsList from './pages/ProjectsList';
import PeopleList from './pages/PeopleList';
import TimeTracking from './pages/TimeTracking';
import ProjectDetail from './pages/ProjectDetail';
import PersonDetail from './pages/PersonDetail';
import Summary from './pages/Summary';
import KanbanComercial from './pages/KanbanComercial';
import KanbanOperaciones from './pages/KanbanOperaciones';
import TablaDesarrolloNegocio from './pages/TablaDesarrolloNegocio';
import TablaOperaciones from './pages/TablaOperaciones';
import TablaHitosFacturacion from './pages/TablaHitosFacturacion';
import Operaciones from './pages/Operaciones'; // Componente unificado de operaciones
import DesarrolloNegocio from './pages/DesarrolloNegocio'; // Componente unificado de desarrollo de negocio
import CrearOportunidad from './pages/CrearOportunidad';
import EditarIniciativa from './pages/EditarIniciativa';
import AnalisisCostes from './pages/AnalisisCostes';
import Innovation from './pages/Innovation';
import CrearIniciativaInnovacion from './pages/CrearIniciativaInnovacion';
import ControlPresupuesto from './pages/ControlPresupuesto';
import './App.css';
import CrearIniciativa from './pages/CrearIniciativa';

const ManagerRoute = ({ children }) => {
  const { user } = useAuth();
  return user?.can_view_pedidos ? children : <Navigate to="/" replace />;
};

// Contenido protegido separado para que NotificacionesModal acceda a useNavigate
function AppContent() {
  return (
    <>
      <Navbar />
      <NotificacionesModal />
      <div className="container" style={{ paddingTop: '80px', maxWidth: '95%', flex: '1' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/summary" element={<Summary />} />
          <Route path="/projects" element={<ProjectsList />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/projects/:id/editar" element={<EditarIniciativa />} />
          <Route path="/people" element={<PeopleList />} />
          <Route path="/people/:id" element={<PersonDetail />} />
          <Route path="/time-tracking" element={<TimeTracking />} />
          <Route path="/hitos-facturacion" element={<TablaHitosFacturacion />} />
          <Route path="/desarrollo-negocio" element={<DesarrolloNegocio />} />
          <Route path="/operaciones" element={<Operaciones />} />
          {/* Rutas de compatibilidad - redirigen a vistas unificadas */}
          <Route path="/kanban-comercial" element={<DesarrolloNegocio />} />
          <Route path="/tabla-desarrollo-negocio" element={<DesarrolloNegocio />} />
          <Route path="/kanban-operaciones" element={<Operaciones />} />
          <Route path="/tabla-operaciones" element={<Operaciones />} />
          <Route path="/crear-oportunidad" element={<CrearOportunidad />} />
          <Route path="/crear-iniciativa" element={<CrearIniciativa />} />
          <Route path="/analisis-costes" element={<AnalisisCostes />} />
          <Route path="/innovation" element={<Innovation />} />
          <Route path="/crear-iniciativa-innovacion" element={<CrearIniciativaInnovacion />} />
          {/* Módulo de Control de Pedidos y Presupuesto */}
          <Route path="/presupuesto" element={<ManagerRoute><ControlPresupuesto /></ManagerRoute>} />
          <Route path="/pedidos" element={<Navigate to="/presupuesto" replace />} />
          <Route path="/pedidos/nuevo" element={<Navigate to="/presupuesto" replace />} />
          <Route path="/pedidos/:id/editar" element={<Navigate to="/presupuesto" replace />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <OperacionesCacheProvider>
        <Router>
          <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <ProtectedRoute>
              <AppContent />
            </ProtectedRoute>
          </div>
        </Router>
      </OperacionesCacheProvider>
    </AuthProvider>
  );
}

export default App;